import { Pipe, PipeTransform } from '@angular/core';
import { StatusZawiadomienia } from '@interfaces/wnioski/platforma-administratora/enums/status-zawiadomienia';

@Pipe({
  name: 'statusZawiadomienia',
})
export class StatusZawiadomieniaPipe implements PipeTransform {
  transform(value: StatusZawiadomienia): string {
    const { Nowe, Zweryfikowano } = StatusZawiadomienia;

    switch (value) {
      case Nowe:
        return 'bg-warning';
      case Zweryfikowano:
        return 'bg-success';
      default:
        return 'bg-info';
    }
  }
}
